import { LinkButton } from '@cian/ui-kit';
import React, { useCallback, MouseEvent } from 'react';

import { useOfferContext } from '../../../../context';
import { getBookButtonTitle } from './utils';

export function AgentBookButtonContainer() {
  const {
    offer: { externalOfferUrl, isCianPartner, canBeBooked },
    tracking,
  } = useOfferContext();

  const title = getBookButtonTitle(canBeBooked);

  const handleClick = useCallback((e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    tracking.trackPhoneOpened(false);
  }, []);

  if (!isCianPartner) {
    return null;
  }

  return (
    <LinkButton
      onClick={handleClick}
      href={externalOfferUrl}
      fullWidth
      size="XS"
      theme="fill_primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      {title}
    </LinkButton>
  );
}
